module.exports = __webpack_public_path__ + "static/media/circle_06.57f052b2.svg";